import React, { useContext, useState } from 'react';
import Icons from '../Icons';
import { Context } from "../contexts/AppContext";
import { postData } from '../../lib/utils';

function UploadImageBg(props) {
  const [imageFile, setImageFile] = useState(null);
  const { value } = useContext(Context);
  const [appState] = value;
  const [clickType, setClickType]=useState(null)
 

  const { currentFolderData, currentFolderName, currentGalleryName,currentGalleryData } = appState;

  console.log(appState?.adminDetails," DKJKDJFKFD ",currentFolderData, currentFolderName, currentGalleryName,currentGalleryData)
  const optimizeImage = (
  file,
  {
    maxWidth = 1280,
    maxHeight = 1280,
    quality = 0.7,
    mimeType = "image/webp",
  } = {}
) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = () => {
      img.src = reader.result;
    };

    img.onload = () => {
      let { width, height } = img;

      // Maintain aspect ratio
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = width * ratio;
        height = height * ratio;
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) return reject("Image optimization failed");
          const optimizedFile = new File([blob], file.name.replace(/\.\w+$/, ".webp"), {
            type: mimeType,
          });
          resolve(optimizedFile);
        },
        mimeType,
        quality
      );
    };

    img.onerror = reject;
    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
};


  // Handle file input
const handleFileChange = async (event) => {
  const inputId = event.target.id; // 🟢 e.g. "fileInput-logo"
  const typeFromId = inputId.replace("fileInput-", ""); // 🟡 "logo", "background", etc.

  const file = event.target.files[0];
  if (!file) return;

  // 🔹 Convert file size to MB
  const fileSizeMB = file.size / (1024 * 1024);

  // 🔹 Get available credits in MB (assuming appState.adminDetails.credits is stored in MB)
  const availableCreditsMB = appState?.adminDetails?.credits || 0;

  // 🔹 Condition 1: 40MB size limit check
  if (fileSizeMB > 40) {
    const sizeDisplay =
      fileSizeMB >= 1024
        ? `${(fileSizeMB / 1024).toFixed(2)} GB`
        : `${fileSizeMB.toFixed(2)} MB`;
    alert(`❌ File too large (${sizeDisplay}). Maximum allowed size is 40 MB.`);
    return;
  }

  // 🔹 Condition 2: Available credits check
  if (fileSizeMB > availableCreditsMB) {
    const fileSizeDisplay =
      fileSizeMB >= 1024
        ? `${(fileSizeMB / 1024).toFixed(2)} GB`
        : `${fileSizeMB.toFixed(2)} MB`;

    const creditsDisplay =
      availableCreditsMB >= 1024
        ? `${(availableCreditsMB / 1024).toFixed(2)} GB`
        : `${availableCreditsMB.toFixed(2)} MB`;

    alert(
      `⚠️ Not enough credits!\n\nFile size: ${fileSizeDisplay}\nAvailable credits: ${creditsDisplay}`
    );
    return;
  }

  // ✅ If checks passed, proceed
  props.imgOnPrg();
  // 🔥 OPTIMIZE BEFORE UPLOAD
const optimizedFile = await optimizeImage(file, {
  maxWidth: 1280,
  maxHeight: 1280,
  quality: 0.7,
});
  setImageFile(optimizedFile);
  await handleUpload(optimizedFile, typeFromId);
};


  
  // Upload to S3
  const handleUpload = async (file, typeFromId) => {
  
 
    
  try {
    const cleanName = file.name.replace(/[^a-zA-Z0-9_.]/g, "");
    const chunkSize = 5 * 1024 * 1024;
    const totalParts = Math.ceil(file.size / chunkSize);

    console.log(cleanName,"  UUUUUU  ",appState)

 
   const s3Key =
  props.type === "galleryBg"
    ? `${appState?.assetsUrl}/${cleanName}`
    : `${appState?.adminDetails?.id}/assets/${cleanName}`;
console.log("SEEEEEE ",s3Key)
    // 🔥 1. Start multipart
    const { uploadId } = await postData(
          `products/start-multipart-upload?fileName=${encodeURIComponent(
            s3Key
          )}&fileType=${typeFromId}`
        );

    let parts = [];

    // 🔥 2. Upload chunks
    for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
      const start = (partNumber - 1) * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      const { url } = await fetch(
        `${process.env.REACT_APP_API_PATH}products/get-part-url?fileName=${encodeURIComponent(s3Key)}&uploadId=${uploadId}&partNumber=${partNumber}`
      ).then(res => res.json());

      const xhr = new XMLHttpRequest();

      await new Promise((resolve, reject) => {
        xhr.open("PUT", url, true);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            props.imgOnPrg?.();
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            const eTag = xhr.getResponseHeader("ETag");
            parts.push({ ETag: eTag, PartNumber: partNumber });
            resolve();
          } else reject("Upload failed");
        };

        xhr.onerror = () => reject("Network error");

        xhr.send(chunk);
      });
    }

    // 🔥 3. Complete upload
    await fetch(`${process.env.REACT_APP_API_PATH}products/complete-multipart-upload`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fileName: s3Key,
        uploadId,
        parts,
      }),
    });

    // ✅ Done
    props.imgUploadedDone(file, typeFromId);

  } catch (error) {
    console.error("Upload error:", error);
    props.uploadFailed?.(file);
  }
};
  // Optional: Delete from S3
  const deleteFileFromS3 = async (fileName) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/products/delete-file`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fileName }),
      });

      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  return (
    <div  className=''>
    
      
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
       id={`fileInput-${props.type}`} 
        style={{ display: "none" }}
      />

    <button
  onClick={() => document.getElementById(`fileInput-${props.type}`).click()}
  className="btn-yellow"
>
  {props?.txt ? props.txt : "Upload Image"}
</button>
    </div>
  );
}

export default UploadImageBg;
